import React from 'react';
import MagneticButton from '../Miscellaneous/MagneticButton';

const Hero = ({ 
    introText = "Bonjour ! Je suis Olivier Geiger.",
    title = "Des applications iOS intuitives",
    highlightedText = "pour une expérience utilisateur inoubliable. 🚀",
    buttonText = "Parlons-en !",
    description = "Je conçois et développe des applications mobiles iOS avec une attention particulière à l’UI (interface utilisateur) et à l’UX (expérience utilisateur). Mon objectif est de créer des applications intuitives, esthétiques et performantes, en mettant l’accent sur l’ergonomie et l’accessibilité. Grâce aux dernières technologies Apple (Swift, SwiftUI) et aux principes de design modernes, j’offre des solutions fluides et engageantes adaptées aux besoins des utilisateurs. 📱",
    bgImage1 = "/img/hero-bg-1.svg",
    bgImage2 = "/img/hero-bg-2.svg"
}) => {
    return (
        <section id="home" className="hero-section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        {/* Hero Content */}
                        <div className="hero-content">
                            <span className="intro-text">{introText}</span>
                            <h1 className="title section-title mt-3 mt-md-4 mb-md-5">
                                {title} <span>{highlightedText}</span>
                            </h1>

                            {/* Content */}
                            <div className="content d-flex flex-column flex-md-row justify-content-md-between">
                                <div className="hero-button order-last order-md-first mt-4 mt-md-0">
									<MagneticButton 
										href="/contact"
										>
										{buttonText}
									</MagneticButton>
                                </div>
                                <p className="sub-title order-first order-md-last">{description}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="hero-bg">
                <img className="circle-1" src={bgImage1} alt="Background 1" />
                <img className="circle-2" src={bgImage2} alt="Background 2" />
            </div>
        </section>
    );
};

export default Hero;
